export default __webpack_public_path__ + "static/media/photo--lg--misc-11.3ff9bf90.jpg";